import React, { memo, useEffect } from 'react';
import { Box, CircularProgress, Modal } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { partnerProfileDrawerIsOpenSelector } from '../../store/modules/ui/selectors';
import { fhwSliceActions } from '../../store/modules/fhw/reducer';
import { uiSliceActions } from '../../store/modules/ui/reducer';
import clsx from 'clsx';
import { apiUrlsSelector, selectedPartnerSelector } from '../../store/modules/fhw/selectors';
import { useGetPartnerProfileQuery } from '../../store/modules/services/searchPartnersApi/searchPartnersApi';
import { translationsSelector } from '../../store/modules/translations/selectors';
import { useStyles } from './styles';
import { fromEvent } from 'rxjs';
import PartnerProfileModalContent from "./PartenrProfileModalContent";

const style = {
	position: 'absolute' as const,
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100vw',
	maxWidth: '1920px',
	margin: '0 auto',
	flexShrink: 0,
	bgcolor: 'background.paper',
	boxShadow: 24,
	overflowY: "scroll",
	zIndex: 100,
	maxHeight: "100%",
	p: 4
};

const PartnerProfileModal = (): JSX.Element | null => {

	const dispatch = useDispatch();
	const isPartnerModalVisible = useSelector(partnerProfileDrawerIsOpenSelector);
	const selectedPartnerId = useSelector(selectedPartnerSelector);
	const apiUrls = useSelector(apiUrlsSelector);
	const internalClasses = useStyles();

	useEffect(() => { closeIndividualProfileDrawerBackdropClick(); });

	const { data, isLoading } = useGetPartnerProfileQuery(
		{ value: selectedPartnerId, endpoint: apiUrls?.getPartnerProfile },
		{ skip: !selectedPartnerId },
	);
	const { partnerProfileGetBackToList } = useSelector(translationsSelector);

	const [modaldata, modaldataSet] = React.useState(undefined);
	React.useEffect(() => { if (data) modaldataSet(data?.data) }, [data, modaldataSet]);

	const closeIndividualProfileDrawer = () => {
		dispatch(fhwSliceActions.setSelectedPartner(undefined));
		dispatch(uiSliceActions.setIsIndividualProfileDrawerOpen({ isOpen: false }));
		modaldataSet(undefined);
	};

	/** Temporary fix for MUI Drawer bug **/
	const closeIndividualProfileDrawerBackdropClick = () => {
		const outside = document.querySelector(".o-fhw-search");
		const header = document.querySelector(".MuiBox-root.MuiBox-root-7.Component-root-5");
		fromEvent(window, 'click').subscribe((e: MouseEvent) => {
			if (e.target === outside || e.target === header) {
				closeIndividualProfileDrawer();
				window.scrollTo(e.x, e.y);
			}
		});
	}

	return (
		<Modal
			className={clsx(internalClasses.modal, internalClasses.root)}
			open={isPartnerModalVisible}
			BackdropProps={{ style: { position: 'absolute', zIndex: 2 } }}
			classes={{ paper: internalClasses.drawerPaper }}
			disablePortal
			onClose={closeIndividualProfileDrawer}>
			<Box sx={style} position="relative" py={4} height="100%">
				{isLoading
					? (<Box display="flex" flexDirection="column" width="100%" height="100%" alignItems="center" justifyContent="center">
						<CircularProgress />
					</Box>)
					: (isPartnerModalVisible && !isLoading)
						? <PartnerProfileModalContent
							buttonClassName={internalClasses.button}
							gobackbuttonText={partnerProfileGetBackToList}
							data={modaldata}
						/>
						: null
				}
			</Box>
		</Modal>
	);
};

export default memo(PartnerProfileModal);
